<div class="modal-wrapper">
    <div class="modal-header modal-h">
        <h5 class="modal-title" *ngIf="actionType === 'edit' && addressType === 'billing'">{{'ADD_EDIT_FORM.EDIT_TITLE_BILLING' | translate}}</h5>
        <h5 class="modal-title" *ngIf="actionType === 'edit' && addressType === 'shipping'">{{'ADD_EDIT_FORM.EDIT_TITLE_SHIPPING' | translate}}</h5>
        <h5 class="modal-title" *ngIf="actionType !== 'edit' && addressType === 'billing'">{{'ADD_EDIT_FORM.ADD_TITLE_BILLING' | translate}}</h5>
        <h5 class="modal-title" *ngIf="actionType !== 'edit' && addressType === 'shipping'">{{'ADD_EDIT_FORM.ADD_TITLE_SHIPPING' | translate}}</h5>
        <button type="button" class="btn-close" (click)="closeBtnClick()" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-b">
        <form [formGroup]="addAddressForm" (ngSubmit)="addAddress()">
            <h5>{{'ADD_EDIT_FORM.CONTACT_TITLE' | translate}}</h5>
            <div class="form-group" *ngIf="addressType === 'shipping' && actionType !== 'edit'">
                <div class="custom-control custom-checkbox">
                    <input class="custom-control-input" type="checkbox" formControlName="useSameForBilling" id="useSameForBilling"
                           tabindex="4"/>
                    <label class="custom-control-label" for="useSameForBilling">
                        {{'ADD_EDIT_FORM.SAME' | translate}}
                    </label>
                </div>
            </div>
            <div class="form-group">
                <label for="name" class="">
                  {{'ADD_EDIT_FORM.CONTACT_NAME_LABEL' | translate}}
                  <span class="text-danger">*</span>
                </label>
                <div>
                    <input type="text" class="form-control" formControlName="name" id="name"
                           placeholder="{{'ADD_EDIT_FORM.CONTACT_NAME_PLACEHOLDER' | translate}}">
                    <div *ngIf="addAddressForm.controls.name?.touched && addAddressForm.controls.name?.errors?.required"
                         class="invalid-feedback">
                        {{'ADD_EDIT_FORM.CONTACT_NAME_REQUIRED' | translate}}
                    </div>
                </div>
            </div>
            <div class="form-group">
                <label for="phoneNumber" class="">
                  {{'ADD_EDIT_FORM.CONTACT_PHONE_LABEL' | translate}}
                  <span class="text-danger">*</span>
                </label>
                <div class="masked-field">
                    <app-masked-input [masked]="!showPhone" inputMode="numeric" formControlName="phoneNumber" id="phoneNumber"
                           placeholder="{{'ADD_EDIT_FORM.CONTACT_PHONE_PLACEHOLDER' | translate}}"></app-masked-input>
                    <span class="mask-toggle" (click)="showPhone = !showPhone">
                      <i class="feather" [ngClass]="showPhone ? 'icon-eye-off' : 'icon-eye'"></i>
                    </span>
                        <div *ngIf="addAddressForm.controls.phoneNumber.errors  && (addAddressForm.controls.phoneNumber.dirty || addAddressForm.controls.phoneNumber.touched)"
                           class="invalid-feedback"
                           [ngClass]="{ 'd-block': addAddressForm.controls.phoneNumber.errors && (addAddressForm.controls.phoneNumber.dirty || addAddressForm.controls.phoneNumber.touched) }"
                        >
                            <div *ngIf="addAddressForm.controls.phoneNumber.errors.required">{{'ADD_EDIT_FORM.CONTACT_PHONE_REQUIRED' | translate}}</div>
                            <div *ngIf="addAddressForm.controls.phoneNumber.errors.pattern">{{'ADD_EDIT_FORM.CONTACT_PHONE_VALID' | translate}}</div>
                    </div>
                </div>
            </div>
            <h5 class="mt-27">{{'ADD_EDIT_FORM.ADDRESS_TITLE' | translate}}</h5>
            <div class="form-group">
                <label id="countyPickerLabel" for="countyPicker" class="">
                  {{'ADD_EDIT_FORM.CONTACT_COUNTY_LABEL' | translate}}
                  <span class="text-danger">*</span>
                </label>
                <div>
                  <ng-select [items]="countyLabels"
                             [closeOnSelect]="true"
                             [searchable]="true"
                             bindLabel="name"
                             bindValue="value"
                             id="countyPicker"
                             [attr.aria-labelledby]="'countyPickerLabel'"
                             placeholder="{{ 'ADD_EDIT_FORM.SELECT_LOCATIONS' | translate }}"
                             formControlName="county"
                             [searchFn]="customSearchFn"
                  >
                    <ng-template ng-label-tmp let-item="item" let-clear="clear">
                      {{ item.name | translate }}
                      <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
                    </ng-template>

                    <ng-template ng-option-tmp let-item="item">
                      {{ item.name | translate }}
                    </ng-template>
                  </ng-select>
                  <div *ngIf="addAddressForm.controls.county?.errors?.required"
                       class="invalid-feedback">
                    {{'ADD_EDIT_FORM.CONTACT_COUNTY_REQUIRED' | translate}}
                  </div>
                </div>
            </div>
            <div class="form-group">
                <label for="city" class="">
                  {{'ADD_EDIT_FORM.CONTACT_CITY_LABEL' | translate}}
                  <span class="text-danger">*</span>
                </label>
                <div>
                    <input type="text" class="form-control" formControlName="city" id="city"
                           placeholder="{{'ADD_EDIT_FORM.CONTACT_CITY_PLACEHOLDER' | translate}}">
                    <div *ngIf="addAddressForm.controls.city?.touched &&
            addAddressForm.controls.city?.errors?.required"
                         class="invalid-feedback">
                        {{'ADD_EDIT_FORM.CONTACT_CITY_REQUIRED' | translate}}
                    </div>
                </div>
            </div>
            <div class="form-group">
                <label for="street" class="">
                  {{'ADD_EDIT_FORM.CONTACT_ADDRESS_LABEL' | translate}}
                  <span class="text-danger">*</span>
                </label>
                <div>
                    <input type="text" class="form-control"
                           placeholder="{{'ADD_EDIT_FORM.CONTACT_ADDRESS_PLACEHOLDER' | translate}}"
                           formControlName="street" id="street">
                    <div *ngIf="addAddressForm.controls.street?.touched &&
            addAddressForm.controls.street?.errors?.required"
                         class="invalid-feedback">
                        {{'ADD_EDIT_FORM.CONTACT_ADDRESS_REQUIRED' | translate}}
                    </div>
                </div>
            </div>
            <div class="form-group">
                <label for="number" class="">
                  {{'ADD_EDIT_FORM.CONTACT_NUMBER_LABEL' | translate}}
                  <span class="text-danger">*</span>
                </label>
                <div>
                    <input type="text" class="form-control"
                           id="number"
                           placeholder="{{'ADD_EDIT_FORM.CONTACT_NUMBER_PLACEHOLDER' | translate}}"
                           formControlName="number" id="number">
                    <div *ngIf="addAddressForm.controls.number?.touched &&
            addAddressForm.controls.number?.errors?.required"
                         class="invalid-feedback">
                        {{'ADD_EDIT_FORM.CONTACT_NUMBER_REQUIRED' | translate}}
                    </div>
                </div>
            </div>
            <div class="form-group">
                <label for="number" class="">
                  {{'ADD_EDIT_FORM.CONTACT_ZIP_LABEL' | translate}}
                  <span class="text-danger">*</span>
                </label>
                <div>
                    <input type="text" class="form-control"
                           id="zipCode"
                           placeholder="{{'ADD_EDIT_FORM.CONTACT_ZIP_PLACEHOLDER' | translate}}"
                           formControlName="zipCode">
                    <div *ngIf="addAddressForm.controls.zipCode?.touched &&
            addAddressForm.controls.zipCode?.errors?.required"
                         class="invalid-feedback">
                        {{'ADD_EDIT_FORM.CONTACT_ZIP_REQUIRED' | translate}}
                    </div>
                </div>
            </div>
            <div class="form-group">
                <label for="number" class="">{{'ADD_EDIT_FORM.CONTACT_BUILDING_LABEL' | translate}}</label>
                <div>
                    <input type="text" class="form-control"
                           id="building"
                           placeholder="{{'ADD_EDIT_FORM.CONTACT_BUILDING_PLACEHOLDER' | translate}}"
                           formControlName="building" id="building" />
                </div>
            </div>
            <div class="form-group">
                <label for="number" class="">{{'ADD_EDIT_FORM.CONTACT_STAIRCASE_LABEL' | translate}}</label>
                <div>
                    <input type="text" class="form-control"
                           id="staircase"
                           placeholder="{{'ADD_EDIT_FORM.CONTACT_STAIRCASE_PLACEHOLDER' | translate}}"
                           formControlName="staircase" id="staircase" />
                </div>
            </div>
            <div class="form-group">
                <label for="number" class="">{{'ADD_EDIT_FORM.CONTACT_FLOOR_LABEL' | translate}}</label>
                <div>
                    <input type="text" class="form-control"
                           id="floor"
                           placeholder="{{'ADD_EDIT_FORM.CONTACT_FLOOR_PLACEHOLDER' | translate}}"
                           formControlName="floor" id="floor" />
                </div>
            </div>
            <div class="form-group">
                <label for="number" class="">{{'ADD_EDIT_FORM.CONTACT_APARTMENT_LABEL' | translate}}</label>
                <div>
                    <input type="text" class="form-control"
                           id="apartment"
                           placeholder="{{'ADD_EDIT_FORM.CONTACT_APARTMENT_PLACEHOLDER' | translate}}"
                           formControlName="apartment" id="apartment" />
                </div>
            </div>
            <div class="modal-f space-between">
                <button type="submit" class="btn btn-primary" *ngIf="actionType === 'edit'"
                        [disabled]="addAddressForm.invalid">{{'ADD_EDIT_FORM.EDIT' | translate}}</button>
                <button type="submit" class="btn btn-primary" *ngIf="actionType !== 'edit'"
                        [disabled]="addAddressForm.invalid">{{'ADD_EDIT_FORM.SAVE' | translate}}</button>
                <button type="button" class="btn btn-secondary"
                        (click)="closeBtnClick()">{{'ADD_EDIT_FORM.CLOSE' | translate}}</button>
            </div>
        </form>
    </div>
</div>
